(function () {
  'use strict';

  angular.module('unit.type.change').factory('UnitTypeChange', UnitTypeChange);

  UnitTypeChange.$inject = ['$resource'];

  function UnitTypeChange($resource) {
    return $resource(
      '/api/',
      {},
      {
        updateType: { method: 'POST', url: '/api/unit/update_type' },
      },
    );
  }
})();
